import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import { IconButton } from "@mui/material";
import { useCallback } from "react";
import { DELETE_NODE_COMMAND } from "../../../types/commands";

import type { DataTableNode } from "../../../nodes/data-table-node";
import type { FC } from "react";

export const DataTableDelete: FC<{ tableNode: DataTableNode }> = ({ tableNode }) => {
  const [editor] = useLexicalComposerContext();
  const handleDelete = useCallback(() => {
    editor.update(() => {
      editor.dispatchCommand(DELETE_NODE_COMMAND, tableNode.getKey());
    });
  }, [editor, tableNode]);

  return (
    <IconButton
      data-analytics-id="lexical-table-menu-delete"
      sx={{ color: "error.main" }}
      onClick={handleDelete}
      size="small"
    >
      <DeleteOutline />
    </IconButton>
  );
};
